module.exports = __webpack_public_path__ + "img/emoji_30.13d486af.png";